import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/5.mp3"
export default function P1() {
    return (
        <MainLayout
        title="Szutrowa droga"     
        question="Może mi pan pomoże?" 
            audio={audio}
        answers={{
            ans1: "Czemu nie, masz pan drugi koszyk?",
            ans2: "A załatwi mi pan pracę w miasteczku?",    
            ans3: "Nie mogę, spieszę się do kantoratu."
        }}
        links={{
            link1: PAGES.p7,
            link2: PAGES.p8,
            link3: PAGES.p9
        }}
        content={
            <div>
                <p>
                Wiatr wieje coraz mocniej, a twoje nogi grzęzną w błocie. Rytmiczny plusk twoich kroków przerywa nagle pytanie zza płotu.
                </p>
                <ul>
                    <li>
                    Może mi pan pomoże? – pyta człowiek zbierający śliwki w sadzie przy drodze, uśmiechając się do ciebie szczerze.
                    </li>
                </ul>
            </div>
        }
        />
        
            );
}